export = {
  POSITIONS: {
    LW: "Tiền đạo cánh trái",
    RW: "Tiền đạo cánh phải",
    ST: "Tiền đạo",
    AM: "Tiền vệ tấn công",
    ML: "Tiền vệ cánh trái",
    MC: "Tiền vệ trung tâm",
    MR: "Tiền vệ cánh phải",
    DM: "Tiền vệ phòng ngự",
    DL: "Hậu vệ trái",
    DC: "Hậu vệ trung tâm",
    DR: "Hậu vệ phải",
    GK: "Thủ môn",
  },
  SHORT_POSITIONS: {
    F: "Tiền đạo",
    M: "Tiền vệ",
    D: "Hậu vệ",
    G: "Thủ môn",
    O: "Vị trí khác",
  },
  TRANSFERS_TYPE: {
    1: "Cho mượn cầu thủ",
    2: "Hết thời gian cho mượn",
    3: "Chuyển nhượng",
    4: "Nghỉ hưu",
    5: "Dự thảo",
    6: "Kết thúc hợp đồng",
    7: "Đã ký kết",
    8: "Khác",
  },
};
